<!--
  空状态!
-->
<template>
  <div>
    <div class="container">
      <div class="empty-img">
        <img src="@/assets/images/empty.jpg"
             alt="">
      </div>
      <div class="empty-title">
        {{data.emptyTitle}}
      </div>
      <!-- <div class="empty-subtitle">
              {{data.emptySubtitle}}
          </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    data: {
      type: Object,
      require: false,
      default: () => {
        return {
          emptyTitle: '暂无数据',
          emptySubtitle: '还没有数据哦，去看看别的吧！'
        }
      }
    }
  },
  data () {
    return {}
  },
  methods: {

  }
}

</script>

<style lang="scss" scoped>
.container {
  display: block;
  //  margin: 120px auto;
}

.empty-img {
  img {
    display: block;
    width: 565px;
    height: 331px;
    margin: 0 auto;
  }
}

.empty-title {
  font-size: 18px;
  color: #999999;
  text-align: center;
  margin: 25px 0 15px 0;
}

.empty-subtitle {
  font-size: 18px;
  color: #999999;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/empty.vue